import { gql } from '@apollo/client';

export const fetchPaymentMethodsForTransactionAccount = gql`
  query fetchPaymentMethodsForTransactionAccount($id: ID!) {
    transactionAccount(id: $id) {
      id
      updatePaymentMethodLink
      availableInvoiceGroups {
        nodes {
          id
          defaultPaymentMethod {
            id
            type
            paymentIssue
          }
        }
      }
      availablePaymentMethods {
        totalCount
        nodes {
          id
          paymentIssue
          type
          default
          ... on CreditCard {
            card {
              expirationMonth
              expirationYear
              last4Numbers
              brand
              cardHolderName
            }
          }
          ... on PaymentOnTerms {
            terms {
              invoiceDueDays
            }
          }
        }
      }
      customerBalances {
        usd
      }
    }
  }
`;
